import { ReactNode } from "react";
import { Box, Button, Text } from "@mantine/core";
import { STYLE } from "../types/constants";

interface Props {
  content: ReactNode;
  intent?: "info" | "warning" | "error";
  actionButton?: {
    onClick: () => void;
    label: string;
  };
}

export const Banner = ({ actionButton, content, intent = "info" }: Props) => {
  let backgroundColor = STYLE.primary;

  switch (intent) {
    case "info":
      backgroundColor = STYLE.primary;
      break;
    case "warning":
      backgroundColor = "orange";
      break;
    case "error":
      backgroundColor = "red";
      break;
  }

  return (
    <Box
      bg={backgroundColor}
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "16px 24px",
        borderRadius: "8px",
        marginBottom: "16px",
      }}
    >
      <Box>
        {typeof content === "string" ? (
          <Text size="md" fw={600} style={{ color: "white" }}>
            {content}
          </Text>
        ) : (
          content
        )}
      </Box>
      {actionButton && (
        <Button
          variant="white"
          color="dark"
          onClick={actionButton.onClick}
          styles={{
            root: {
              backgroundColor: "white",
              color: STYLE.primary,
              "&:hover": {
                backgroundColor: "#f8f9fa",
              },
            },
          }}
        >
          {actionButton.label}
        </Button>
      )}
    </Box>
  );
};
